import Decimal from "decimal.js";

export const required = {
  required: true,
  message: "To pole jest wymagane",
  trigger: "blur",
};

export const maxLength = (length: number) => ({
  max: length,
  message: `Pole nie może być dłuższe niż ${length}.`,
  trigger: "blur",
});

const urlPattern = new RegExp(
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{2,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
);

export const urlValidator = {
  validator: (rule: any, value: any, callback: any) => {
    if (!value) callback();
    else if (!urlPattern.test(value))
      callback(new Error("Wartość musi być poprawnym adresem URL."));
    else callback();
  },
  trigger: "blur",
};

const postCodePattern = new RegExp(/^[0-9]{2}-[0-9]{3}$/);

export const postCodeValidator = {
  validator: (rule: any, value: any, callback: any) => {
    if (!value) callback();
    else if (!postCodePattern.test(value))
      callback(new Error("Wartość musi być poprawnym kodem pocztowym."));
    else callback();
  },
  trigger: "blur",
};
